import theme from '../../utils/theme/theme';

const ButtonStyles = {
  fontWeight: 600,
  fontSize: '18px',
  color: theme.palette.custom.mediumDarkGrey,
};

export default ButtonStyles;
